import { FC } from 'react';

import MuiButton from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

import { ButtonProps } from './interfaces';

const Button: FC<ButtonProps> = ({ children, loading, startIcon, ...rest }) => {
  const progressColor = rest.color !== 'default' ? rest.color : 'primary';

  return (
    <MuiButton
      startIcon={
        loading ? (
          <CircularProgress color={progressColor} size={24} />
        ) : (
          startIcon
        )
      }
      disabled={loading}
      {...rest}
    >
      {children}
    </MuiButton>
  );
};

export default Button;
